import { Component } from '@angular/core';
import { Route } from '@angular/router';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { APP_ROUTES } from '../app-routing.module';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { AccountService } from './services/account.service';

@Component({
  selector: 'side-navigation-bar',
  templateUrl: './side-navigation-bar.component.html'
})
export class SideNavigationBarComponent {

  private permittedRoutes$: Observable<Array<Route>>;
  public routesSidebar$: Observable<Array<Route>>;
  public routesSubpanel$: Observable<Array<Route>>;
  public user$: Observable<any>;
  public show = true;
  public isCollapsed: Array<boolean> = [];
  isAdmin$: Observable<boolean>;

  constructor(
    private accountService: AccountService,
    private authenticationSelectors: AuthenticationSelectors) {

      // Get link'able part of path from each route to use for routerLink
      for (const route of APP_ROUTES) {
          if (route.data) {
              route.data.routerLink = route.path.includes(':')
                  ? route.path.substring(0, route.path.indexOf(':') - 1)
                  : route.data.routerLink = route.path;
          }
      }

      this.user$ = this.authenticationSelectors.selectCurrentUser();
      this.isAdmin$ = this.authenticationSelectors.selectIsAdmin();

      this.permittedRoutes$ = this.user$
      .pipe(
        map(user =>
          APP_ROUTES.filter(route =>
            this.accountService.hasUserPermission(route, user)))
      );

      this.routesSubpanel$ = this.permittedRoutes$
      .pipe(
        map(routes =>
          routes.filter(route =>
            route.data !== undefined &&
            route.data.sidebar !== undefined &&
            route.data.sidebar !== 'group')
        )
      );

      this.routesSidebar$ = this.permittedRoutes$
      .pipe(
        map(routes =>
          routes.filter(route =>
            route.data !== undefined &&
            route.data.sidebar !== undefined &&
            route.data.sidebar === 'group')
        )
      );
  }
}
